function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import * as R from 'unitx/ramda';
import { registerAnimation } from "../animation";
export const defaultSettings = {};
export const SettingsContext = /*#__PURE__*/React.createContext({
  dispatch: () => null
}); // Actions
// const ADD_POPUP = 'ADD_POPUP'
// Action Creators

// const typeIs = R.propEq('type')
const reducer = (state = defaultSettings, action) => R.cond([[R.T, R.always(state)]])(action);

export const SettingsProvider = props => {
  const {
    children,
    animations
  } = props;
  const [settings, dispatch] = React.useReducer(reducer, {});
  /* eslint-disable functional/immutable-data,functional/no-expression-statement */

  React.useEffect(() => {
    // register animations
    R.mapObjIndexed(animations, (anim, key) => registerAnimation(key, anim));
  }, [animations]);

  const value = _objectSpread({
    dispatch
  }, settings);
  /* eslint-enable functional/immutable-data,functional/no-expression-statement */


  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(SettingsContext.Provider, {
      value: value
    }, children)
  );
};
export const useSettings = () => {
  const value = useContext(SettingsContext);
  return value;
};